import { useNavigate } from "@solidjs/router";
import ServicesPanel from "./ServicesPanel";

// Route wrapper for /services — kept so anything that navigates here
// directly keeps working. The actual UI lives in ServicesPanel so it can
// also be shown inline (see Home.tsx, where selecting "Services" in the
// header shows this without navigating away and losing the header row).
const ServicesPage = () => {
    const navigate = useNavigate();

    return <ServicesPanel onEscape={() => navigate("/home")} />;
};

export default ServicesPage;
